module.exports = __webpack_public_path__ + "img/left2.ecc5e53d.jpg";